import { Divider, Grid, Container } from "@material-ui/core";
import logo from "../../assets/logo.png";
import instagram from "../../assets/instagram-2.svg";
import twitter from "../../assets/twitter-2.svg";
import discord from "../../assets/discord-2.svg";

import "./index.less";

export default function Footer() {
  return (
    <div className="footer">
      <Container maxWidth="lg">
        {/* <Divider variant="middle" className="footer-divider" /> */}
        <Grid container direction="column" alignItems="center" justify="center">
          <Grid item xs={12} md={4}>
            <img src={logo} width="100%" alt="" className="footer-logo" />
          </Grid>
          <Grid item xs={12} md={3}>
            <Grid
              container
              className="social"
              alignItems="center"
              justify="center"
            >
              {/* <Grid item xs={4} className="social-icon">
                <img src={instagram} width="30%" alt="" />
              </Grid> */}
              <Grid item xs={4} className="social-icon">
                <a
                  href="https://twitter.com/KungFuHeroNFT"
                  target="blank"
                  style={{ textAlign: "center" }}
                >
                  <img src={twitter} width="30%" alt="" />
                </a>
              </Grid>
              <Grid item xs={4} className="social-icon">
                <a
                  href="https://discord.gg/xPW5pjnZAJ"
                  target="blank"
                  style={{ textAlign: "center" }}
                >
                  <img src={discord} width="30%" alt="" />
                </a>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}
